import { useState } from "react";

import type { ReviewListAction, ReviewPanelItem } from "./ReviewPanel";

type ReviewEditingResult = {
  editingKey: string | null;
  editValue: string;
  setEditValue: (value: string) => void;
  startEditing: (key: string, initial?: string) => void;
  saveEditing: (reviewItem: ReviewPanelItem["reviewItems"][number]) => void;
  cancelEditing: () => void;
};

export const useReviewEditing = (
  onUpdate: (action: ReviewListAction) => void,
): ReviewEditingResult => {
  const [editingKey, setEditingKey] = useState<string | null>(null);
  const [editValue, setEditValue] = useState<string>("");

  const startEditing = (key: string, initial = ""): void => {
    setEditingKey(key);
    setEditValue(initial ?? "");
    onUpdate({ type: "startEdit", payload: { key } });
  };

  const saveEditing = (
    reviewItem: ReviewPanelItem["reviewItems"][number],
  ): void => {
    if (!editingKey) return;

    onUpdate({
      type: "saveComment",
      payload: {
        comment: editValue,
        fieldCommentId: reviewItem.fieldCommentId,
        fieldPath: reviewItem.fieldPath,
        planId: reviewItem.planId,
      },
    });
    setEditingKey(null);
    setEditValue("");
  };

  const cancelEditing = (): void => {
    setEditingKey(null);
    setEditValue("");
  };

  return {
    editingKey,
    editValue,
    setEditValue,
    startEditing,
    saveEditing,
    cancelEditing,
  };
};
